module.exports = __webpack_public_path__ + "static/media/testScreenShot.c421fd9f.png";